import React from "react";
import { SERVICES } from "./../constant/services";
import "./Service.css";
import { Link } from "react-router-dom";
import services from "./../assets/images/services.webp";

const Service = ({ setShowServices }) => {
  return (
    <div className="service-root">
      <div className="service-main-link">
        <div className="service-main-link-content">
          <img src={services} alt="icon" />
          <Link
            to={"/services"}
            onClick={() => setShowServices(false)}
            className="service-main-link-text"
          >
            Our Services
          </Link>
        </div>
      </div>
      <div className="service-card-container">
        {SERVICES.slice(0, 6).map((service, idx) => (
          <Link
            to={`/services/${service.slug}`}
            key={idx}
            className="service-card-link"
            onClick={() => setShowServices(false)}
          >
            <div className="service-card-icon">{service.icon}</div>
            <div>
              <div className="service-card-title">{service.title}</div>
              <div className="service-card-desc">{service.description}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Service;
